// extracted by mini-css-extract-plugin
export var articleWrapper = "index-module--articleWrapper--L-BOl";
export var bannerWrapper = "index-module--bannerWrapper--1HmTf";
export var description = "index-module--description--0UVT+";
export var title = "index-module--title--7U7rS";